import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import { type FocusEvent, useState } from 'react';

import Input from '../Input';
import type { InputT } from '../Input/types';
import S from './styled';

const PasswordInput = (props: InputT) => {
  const [isShowPw, setIsShowPw] = useState(false);
  const [isHover, setIsHover] = useState(false);
  const [isFocus, setIsFocus] = useState(false);

  const { sizeType = 's' } = props;

  const handleOnFocusInput = (e: FocusEvent<HTMLInputElement>) => {
    setIsFocus(true);
    props.onFocus?.(e);
  };

  const handleOnBlurInput = (e: FocusEvent<HTMLInputElement>) => {
    setIsFocus(false);
    props.onBlur?.(e);
  };

  return (
    <S.StyledWrapper
      sizeType={sizeType}
      isHover={isHover}
      isFocus={isFocus}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      <Input
        {...props}
        onFocus={handleOnFocusInput}
        onBlur={handleOnBlurInput}
        type={isShowPw ? 'text' : 'password'}
        style={{ paddingRight: 35 }}
      />
      <div className="right-icon" onClick={() => setIsShowPw(!isShowPw)}>
        {isShowPw ? <EyeOutlined /> : <EyeInvisibleOutlined />}
      </div>
    </S.StyledWrapper>
  );
};

export default PasswordInput;
